module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/ko/3-0a0250de4ed6d40a89ff4af5bb8feb6b.jpg";